import React from 'react'
import ReactDOM from 'react-dom'
import './scss/index.scss'
import App from './components/App'
import GlobalContextProvider from "./hooks/reducer"
import ErrorBoundary from './components/common/ErrorBoundary'

// NOTE: <React.StrictMode><App /><React.StrictMode />はmaterial-uiの問題でワーニングが出る
ReactDOM.render(
  // <GlobalContext.Provider value={AppStateData}>
  <GlobalContextProvider>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </GlobalContextProvider>
  , document.getElementById('root')
);
